import { useNavigate, useParams } from 'react-router-dom';
import { EXTENDED_INTERVAL_UPDATE_DATA } from '../../../constants/common';
import { useAppDispatch, useAppSelector } from '../../../store/store';
import { useCallback, useRef, useState } from 'react';
import { usePolling } from '../../../hooks/usePolling';
import { TAB_NUMBER } from '../../ContractScreensView/constants';
import { Contract } from '../../../store/models/contracts';
import { Screen } from '../../../store/models/screens';

export interface ILoadContractScreensProps {
  contracts: Contract[];
  screens: Screen[];

  isLoading: boolean;
  onDeleteScreen: () => Promise<void>;
}

export const useLoadContractScreens = (payload: { tabNumber: number }): ILoadContractScreensProps => {
  const { clientId } = useParams();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);

  const {
    contracts: {
      getContractsByLocation,
    },
    screens: {
      getAllByLocationId,
    },
  } = useAppDispatch();
  const { screens } = useAppSelector((state) => state.screens);
  const { contracts } = useAppSelector((state) => state.contracts);

  const isChangeLoading = useRef(true);

  const fetchDataHandler = async (locationId: string) => {
    try {
      if (!locationId) {
        return;
      }

      if (isChangeLoading.current) {
        setIsLoading(true);
      }

      await getContractsByLocation({ locationId });

      if (payload.tabNumber === TAB_NUMBER.ACTIVE) {
        await getAllByLocationId({ locationId, query: { hasCycles: true } });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
      isChangeLoading.current = false;
    }
  };

  const onDeleteScreenHandler = useCallback(async () => {
    await getAllByLocationId({ locationId: clientId, query: { hasCycles: true } });
  }, [clientId]);

  usePolling(() => fetchDataHandler(clientId), EXTENDED_INTERVAL_UPDATE_DATA, [clientId, navigate]);

  return { contracts, screens, isLoading, onDeleteScreen: onDeleteScreenHandler };
}